import { __assign, __awaiter, __generator } from "tslib";
import { VIDEO_TYPE, FILE_UPLOAD_TYPE } from 'wix-rich-content-common';
import { getMediaFileType } from '../services/getMediaFileType';
export var getVideoUrl = function (src) {
    return "https://video.wixstatic.com/" + src.pathname;
};
var getDomain = function (mediaType, metaSiteId) {
    return ({
        picture: 'static.wixstatic.com',
        video: 'video.wixstatic.com',
        music: 'music.wixstatic.com',
        document: metaSiteId + ".usrfiles.com",
        archive: metaSiteId + ".usrfiles.com",
    }[mediaType]);
};
export var resolveFileUrl = function (metaSiteId) { return function (_a) {
    var id = _a.id, type = _a.type;
    return __awaiter(void 0, void 0, void 0, function () {
        var domain;
        return __generator(this, function (_b) {
            domain = getDomain(getMediaFileType(type), metaSiteId);
            return [2 /*return*/, "https://" + domain + "/" + id];
        });
    });
}; };
export default function urlResolutionStrategy(hasPlugin, metaSiteId, _experiments // eslint-disable-line
) {
    var _a;
    if (!metaSiteId)
        return {};
    return {
        config: (_a = {},
            _a[VIDEO_TYPE] = __assign({}, (hasPlugin(VIDEO_TYPE) && {
                getVideoUrl: getVideoUrl,
            })),
            _a[FILE_UPLOAD_TYPE] = __assign({}, (hasPlugin(FILE_UPLOAD_TYPE) &&
                metaSiteId && {
                resolveFileUrl: resolveFileUrl(metaSiteId),
            })),
            _a),
    };
}
//# sourceMappingURL=urlResolutionStrategy.js.map